



































































































import Vue from 'vue'
import {mapState, mapActions, mapMutations} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'

export default Vue.extend({
    computed: {
        ...mapState('reportAdmin', ['segnalazioneSelezionata', 'storiaSegnalazioneSelezionata']),
        // nuovi dati che verrano inviati con la patch
        nuoviDati(): object {
            return {
                id: this.segnalazioneSelezionata.id,
                segnalazione: {
                    // dati convertiti
                    ...this.segnalazioneSelezionata,
                    tipo_segnalazione_id: this.segnalazioneSelezionata.tipo_segnalazione.id,
                    stato_segnalazione_id: this.segnalazioneSelezionata.stato_segnalazione.id,
                    ente_gestore_segnalazione_id: this.segnalazioneSelezionata.ente_gestore_segnalazione.id
                }
            }
        }
    },
    watch: {
        // quando cambia la segnalazione selezionata
        segnalazioneSelezionata: {
            immediate: true,
            // carichiamo la storia delle modifiche alla segnalazione
            handler(newValue) {
                this.caricaStoriaSegnalazione(newValue.id)
            }
        }
    },
    methods: {
        ...mapActions('reportAdmin', ['caricaStoriaSegnalazione']),
        ...mapActions('modal', ['showModal']),
        ...mapMutations('reportAdmin', ['SET_NUOVI_DATI']),
        // la data di rilevamento scritta in modo leggibile
        dataParsata: (data) => moment(data).format('DD MMMM YYYY, HH:mm')
    },
    mounted() {
        // date italiane
        moment.locale('it')
    }
})
